<template>
    <table class="w-full border">
        <thead>
            <tr>
                <th rowspan="2" class="text-center align-bottom border-b-4">Zone</th>
                <th v-if="pickupZoneTimesLength" :colspan="pickupZoneTimesLength" class="text-center">Pickups</th>
                <th v-if="deliveryZoneTimesLength" :colspan="deliveryZoneTimesLength" class="text-center">Deliveries</th>
                <th rowspan="2" class="text-right align-bottom border-b-4">Total</th>
            </tr>
            <tr>
                <template v-for="time, name, index in data.pickup_zone_times" :key="time.col_name">
                    <td class="text-right text-nowrap subheader border-t-4 border-b-4" :class="{
                        'border-l-4': index === 0,
                        'border-r-4': index + 1 === pickupZoneTimesLength,
                    }">
                        {{ time.title }}
                    </td>
                </template>
                <template v-for="time, name, index in data.delivery_zone_times" :key="time.col_name">
                    <td class="text-right text-nowrap subheader border-t-4 border-b-4" :class="{
                        'border-l-4': index === 0,
                        'border-r-4': index + 1 === deliveryZoneTimesLength,
                    }">
                        {{ time.title }}
                    </td>
                </template>
            </tr>
        </thead>
        <tbody>
            <tr class="border-t" v-for="stats, zone in data.pick_zones" :key="zone">
                <td class="text-right px-4 font-semibold">{{ zone || '--' }}</td>
                <template v-for="time, name, index in data.pickup_zone_times" :key="time.col_name">
                    <td class="text-right" :class="{
                        'border-l-4': index === 0,
                        'border-r-4': index + 1 === pickupZoneTimesLength,
                    }">
                        {{ stats[time.col_name] || '0' }}
                    </td>
                </template>
                <template v-for="time, name, index in data.delivery_zone_times" :key="time.col_name">
                    <td class="text-right" :class="{
                        'border-l-4': index === 0,
                        'border-r-4': index + 1 === deliveryZoneTimesLength,
                    }">
                        {{ stats[time.col_name] || '0' }}
                    </td>
                </template>
                <td class="text-right font-semibold">{{ data.zone_totals[zone] }}</td>
            </tr>
            <tr class="border-t-4">
                <td class="text-center font-semibold">Total</td>
                <template v-for="time in data.pickup_zone_times" :key="time.col_name">
                    <td class="text-right font-semibold">{{ time.total }}</td>
                </template>
                <template v-for="time in data.delivery_zone_times" :key="time.col_name">
                    <td class="text-right font-semibold">{{ time.total }}</td>
                </template>
                <td class="text-right font-semibold">{{ data.zone_totals.grand_total }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: 'ItemPickZones',
    props: ['data'],

    computed: {
        pickupZoneTimesLength() {
            return Object.keys(this.data.pickup_zone_times).length;
        },

        deliveryZoneTimesLength() {
            return Object.keys(this.data.delivery_zone_times).length;
        },
    },
}
</script>

<style scoped>
td, th {
    padding: 0.25rem;
}
</style>